import React from 'react';
import { Backdrop, Box, CircularProgress, Portal, Typography } from '@mui/material';

interface StudioExportLoadingProps {
  intl: any;
  open: boolean;
  progress: number;
}

const stageIds = [
  'hot-topic-studio-export-designing',
  'hot-topic-studio-export-colouring',
  'hot-topic-studio-export-packing',
  'hot-topic-studio-export-thanks',
  'hot-topic-studio-export-almost-done'
];

const getStageIndex = (progress: number) => {
  if (progress < 22) return 0;
  if (progress < 48) return 1;
  if (progress < 74) return 2;
  if (progress < 90) return 3;
  return 4;
};

const StudioExportLoading: React.FC<StudioExportLoadingProps> = ({ intl, open, progress }) => {
  const stageIndex = getStageIndex(progress);

  return (
    <Portal>
      <Backdrop open={open} className="studio-export-loading-backdrop" aria-live="polite">
        <Box className="studio-export-loading-content">
          <CircularProgress color="primary" />
          <Typography component="div" className="studio-export-loading-title">
            {intl.formatMessage({ id: stageIds[stageIndex] })}
            <span className="studio-export-loading-percent"> {Math.round(progress)}%</span>
          </Typography>
        </Box>
      </Backdrop>
    </Portal>
  );
};

export default StudioExportLoading;
